import { useEffect, useState } from "react";
import Flag_Ru from "../../../../common/assets/images/DropdownButton/Flag_of_Russia.svg";
import Flag_En from "../../../../common/assets/images/DropdownButton/Flag_of_the_United_Kingdom.svg";
import Flag_De from "../../../../common/assets/images/DropdownButton/Flag_of_Germany.svg";

import "../styles/LangButton.css";
import { useTranslation } from "react-i18next";

export const LangButton = () => {
  const { i18n } = useTranslation();
  const [LangButton, setSwitcher] = useState<boolean>(false);
  const [Flag_General, setFlag_General] = useState<any>(Flag_Ru);

  // useEffect(() => {
  //     setTimeout(() => {
  //         setSwitcher(false);
  //     }, 5000);
  // }, [LangButton]);
  useEffect(() => {
    if (i18n.language === "de") {
      setFlag_General(Flag_De);
    } else if (i18n.language === "en") {
      setFlag_General(Flag_En);
    } else {
      setFlag_General(Flag_Ru);
    }
  }, [i18n.language]);
  return (
    <div className="LangButton-block">
      <div
        className={
          LangButton ? "LangButton" : "LangButton__OFF LangButton__short"
        }
      >
        {LangButton ? (
          <>
            <img
              src={Flag_Ru}
              className="LangButton_circle_NotActive"
              alt=""
              onClick={(e) => {
                i18n.changeLanguage("ru");
                localStorage.setItem("language", "ru");
                setSwitcher(false);
              }}
              style={i18n.language === "ru" ? { display: "none" } : {}}
            />
            <img
              src={Flag_En}
              className="LangButton_circle_NotActive"
              alt=""
              onClick={(e) => {
                i18n.changeLanguage("en");
                localStorage.setItem("language", "en");
                setSwitcher(false);
              }}
              style={i18n.language === "en" ? { display: "none" } : {}}
            />
            <img
              src={Flag_De}
              alt=""
              onClick={(e) => {
                i18n.changeLanguage("de");
                localStorage.setItem("language", "de");
                setSwitcher(false);
              }}
              style={i18n.language === "de" ? { display: "none" } : {}}
            />
          </>
        ) : (
          ""
        )}
        <div
          className={
            LangButton
              ? "LangButton_circle"
              : "LangButton_circle__OFF LangButton_circle"
          }
        >
          <img
            src={Flag_General}
            alt=""
            onClick={() => {
              setSwitcher(!LangButton);
            }}
          />
        </div>
      </div>
    </div>
  );
};
